<template>
  <v-layout
    wrap
    style="margin-top: 40px;"
  >
    <v-card 
      v-for="(item, i) in data"
      :key="i"
      style="margin-right: 25px;"
      elevation="0"
      >
      <v-btn
        color="red"
        dark
        small
        absolute
        top
        right
        fab
        :elevation="5"
        style="color:white;margin-right:-35px;"
        @click="handleClearImage(item)"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
      <v-img
        :src="item"
        height="120px"
        width="120px" 
        :lazy-src="item"
        aspect-ratio="1.7"
        class="grey lighten-2"
        style="margin-bottom: 20px;border-radius: 10%;border: 0.5px solid #56a09930 !important;"
      />
    </v-card>
    <v-card
      v-if="!limit || !data || data.length < limit"
      style="margin-bottom: 20px;margin-right: 25px;"
      elevation="0"
      >
      <select-image
        v-model="imageNew"
        :icon="'mdi-plus'"
        :imageWidth="1280"
        :imageHeight="853"
        :imageOld='imageOld'
        :aspectRatio="4/3"
        :enterpriseID="enterpriseID"
        @input="handleAddImage"
        style="margin-left:0px;margin-top:0px;"
      />
    </v-card>
  </v-layout>
</template>
<script>
import SelectImage from '@/components/SelectImage'
export default {
  name: 'carousel',
  components: {
    SelectImage
  },
  props: {
    limit: {
      type: Number,
      required: false,
      default: null
    },
    value: {
      type: Array,
      required: true
    },
    closed: {
      type: Boolean,
      required: false
    },
    onAddImage: {
      type: Function,
      required: false,
      default: null
    },
    onClearImage: {
      type: Function,
      required: false,
      default: null
    },
    enterpriseID: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      data: null,
      imageNew: null,
      imageOld: null
    }
  },
  watch: {
    value(v) {
      this.data = v
    }
  },
  mounted () {
    this.data = this.value
  },
  methods: {
    handleClearImage (url) {
      this.onClearImage(url)
      // this.data = this.data.filter(x => x !== url)
      // this.$emit('input', this.data)
      // console.log('clear', url, this.data)
    },
    handleAddImage () {
      this.onAddImage(this.imageNew)
      // this.data.push(this.imageNew)
      this.imageNew = undefined
    }
  }
}
</script>